// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__2RfjL","contained":"OpenButton_contained__6Ph5x","disabled":"OpenButton_disabled__192KU","error":"OpenButton_error__2SB94"};